"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const User_1 = __importDefault(require("@common/models/User"));
const SummaryController_1 = require("@becrop/components/Results/Abstract/Controllers/SummaryController");
const TableSummary_vue_1 = __importDefault(require("./TableSummary.vue"));
const TableSummaryFiltersRow_vue_1 = __importDefault(require("./TableSummaryFiltersRow.vue"));
const TableSummaryLegend_vue_1 = __importDefault(require("./TableSummaryLegend.vue"));
const FilterTag_vue_1 = __importDefault(require("./FilterTag.vue"));
const SummaryMetrics_vue_1 = __importDefault(require("@becrop/components/TrialsSummary/SummaryMetrics.vue"));
const GeneralFeatures_vue_1 = __importDefault(require("@becrop/components/TrialsSummary/GeneralFeatures.vue"));
const floating_vue_1 = require("floating-vue");
const BannerHeader_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/BannerHeader.vue"));
const TrialsResultsMain_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/TrialsResultsMain.vue"));
const TrialsConfiguration_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/Configuration/TrialsConfiguration.vue"));
const TrialsTable_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/Table/TrialsTable.vue"));
const TrialsSummary_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/SummaryRating/TrialsSummary.vue"));
const TrialsResultsMainIntro_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/TrialsResultsMainIntro.vue"));
const TrialsResultsMainTopAction_vue_1 = __importDefault(require("@becrop/components/Results/TrialsResults/UI/TrialsResultsMainTopAction.vue"));
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const axios_1 = __importDefault(require("axios"));
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
let SummaryView = class SummaryView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.user = null;
        this.fetchingSummaryTable = true;
        this.raw_study = null;
        this.raw_project_bag = null;
        this.raw_gheom = null;
        this.isReuseSamplesToast = true;
        //////////
        this.summaryController = new SummaryController_1.SummaryController({ type: this.type, vs: this.isVSMode });
        this.currentMode = 'table';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    dismissFeedbackToast() {
        this.isReuseSamplesToast = false;
    }
    openFeedbackToast() {
        this.isReuseSamplesToast = true;
    }
    changeMode(m) {
        this.currentMode = m;
    }
    get isReuseSamples() {
        if (this.summaryController.configurationData.hasReusingSamples)
            this.isReuseSamplesToast = true;
        return this.summaryController.configurationData.hasReusingSamples;
    }
    //////////
    parseFilterConfigurationToMultipleConfiguration(f) {
        let parsered = f;
        Object.keys(parsered).forEach(key => {
            if (typeof parsered[key] === 'string') {
                parsered[key] = [parsered[key]];
                if (parsered[key][0].length == 0)
                    parsered[key] = [];
            }
        });
        return parsered;
    }
    async downloadCSVConfig(onlyConfig) {
        const url = '/results/api/trials/results-configuration/download/excel';
        let currentFilters = Object.assign({}, this.summaryController.filterConfiguration);
        let filtersActive = this.parseFilterConfigurationToMultipleConfiguration(currentFilters);
        try {
            const data = {
                project_id: this.raw_gheom.project_id,
                gheom_id: this.raw_gheom.id,
                all: onlyConfig ? 0 : 1,
                filters: filtersActive
            };
            const specialCharactersRegex = /[\/.%;!?¿$¡-]/g;
            let name = this.raw_gheom.name;
            const curatedName = name.replace(specialCharactersRegex, '');
            const fileName = onlyConfig ? `${curatedName} - Configuration` : `${curatedName} - Full`;
            const response = await axios_1.default.post(url, data, { responseType: 'blob' });
            (0, downloadFile_1.default)(response.data, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }
        catch (e) {
            console.log(e);
        }
    }
    get trialId() {
        const url = window.location.href;
        const match = url.match(/\/trials\/(\d+)/);
        if (match) {
            const trialNumber = match[1];
            return trialNumber; // Resultado: "272"
        }
        else {
            // console.log('No se encontró el id del trials');
        }
    }
    get tableTitle() {
        return this.summaryController.tableTitle;
    }
    get configurationData() {
        return this.summaryController.configurationData;
    }
    deleteFilter(filterDelete) {
        if (filterDelete === 'location')
            this.changeLocation('');
        if (filterDelete === 'effectType')
            this.changeTime('');
        if (filterDelete === 'category')
            this.changeCategory('');
        if (filterDelete === 'parentCategory')
            this.changeParentCategory('');
        if (filterDelete === 'metric')
            this.changeMetric('');
        if (filterDelete === 'claim')
            this.changeClaim('');
        if (filterDelete === 'relevant') {
            this.changeRelevant(!this.summaryController.filterConfiguration.relevant);
        }
    }
    get allFiltersActives() {
        const activeFilters = {
            category: '',
            claim: '',
            effectname: '',
            location: '',
            metric: '',
            relevant: '',
            effectType: '',
        };
        Object.keys(this.summaryController.filterConfiguration).forEach((clave) => {
            if (this.summaryController.filterConfiguration[clave].length > 0 && clave !== 'effectname') {
                if (clave === 'relevant') {
                    activeFilters[clave] = clave;
                }
                else {
                    activeFilters[clave] = this.summaryController.filterConfiguration[clave];
                }
            }
        });
        const isRelevant = this.summaryController.filterConfiguration.relevant === 'true';
        const filteredActiveFilters = Object.fromEntries(Object.entries(activeFilters).filter(([clave, valor]) => {
            return valor !== '' && (clave !== 'relevant' || (clave === 'relevant' && isRelevant));
        }));
        return filteredActiveFilters;
    }
    get omisibleColumns() {
        return this.summaryController.omisibleColumns;
    }
    get currentFocus() {
        return this.summaryController.currentFocus;
    }
    changeFocus(newFocus) {
        if (this.summaryController.type === 'study') {
            this.summaryController.setFilter('effectname', '');
        }
        this.summaryController.setFocus(newFocus);
    }
    get productSortingDirection() {
        return this.summaryController.productSorting;
    }
    changeProductSortingDirection(v) {
        this.summaryController.changeProductSortingDirection(v);
    }
    get chartCols() {
        return this.summaryController.chartCols;
    }
    get dynamicCols() {
        return this.summaryController.dynamicCols;
    }
    get metadata() {
        return this.summaryController.summary.metadata;
    }
    get thresholds() {
        return this.summaryController.summary.thresholds;
    }
    get workingSummaryTable() {
        return this.summaryController.customSummary;
    }
    get products() {
        return this.summaryController.getAllProducts;
    }
    get effectNames() {
        return this.summaryController.getAllEffectNames;
    }
    get locations() {
        const locationNames = this.summaryController.getAllLocations.map((l) => l.name);
        return [...locationNames];
    }
    get times() {
        const timesNames = this.summaryController.allTimes;
        return timesNames;
    }
    get categories() {
        const categoryNames = this.summaryController.getCurrentCategories.map((c) => c.name).sort();
        return [...categoryNames];
    }
    get parentCategories() {
        const parentCategoryNamesSet = new Set(this.summaryController.getAllParentCategories.map((parentCategory) => parentCategory));
        const uniqueParentCategoryNames = Array.from(parentCategoryNamesSet).sort();
        return uniqueParentCategoryNames;
    }
    get metrics() {
        const metricNames = this.summaryController.getCurrentMetrics.map((m) => m.name).sort();
        return [...metricNames];
    }
    get isShowingOnlyRelevant() {
        if (this.summaryController.filterConfiguration.relevant === 'true')
            return true;
        return false;
    }
    get summaryGlobalData() {
        return this.summaryController.summaryGlobalData;
    }
    changeEffectName(en) {
        this.summaryController.setFilter('effectname', en);
    }
    changeLocation(l) {
        this.summaryController.setFilter('location', l);
    }
    changeCategory(c) {
        this.summaryController.setFilter('category', c);
    }
    changeParentCategory(parentCategory) {
        this.summaryController.setFilter('parentCategory', parentCategory);
    }
    changeMetric(m) {
        this.summaryController.setFilter('metric', m);
    }
    changeClaim(r) {
        this.summaryController.setFilter('claim', r);
    }
    changeTime(r) {
        this.summaryController.setFilter('time', r);
    }
    changeRelevant(r) {
        this.summaryController.setFilter('relevant', r.toString());
    }
    resetAllFilters() {
        this.summaryController.resetAllFilters();
    }
    get hasAFilterActive() {
        return this.summaryController.hasAFilterActive;
    }
    chooseSortable(criteria) {
        this.summaryController.chooseCriteria(criteria);
    }
    get criteria() {
        return this.summaryController.criteria;
    }
    get direction() {
        return this.summaryController.direction;
    }
    get isStudy() {
        return this.type === 'study';
    }
    get tabs() {
        return this.summaryController.tabs;
    }
    get summaryGlobalHasMetrics() {
        const categoryHasMetrics = (categories) => categories.some((category) => category.metrics.length);
        return categoryHasMetrics(this.summaryGlobalData.effCategories) || categoryHasMetrics(this.summaryGlobalData.bioCategories);
    }
    deployLoadingSummaryTable() {
        this.fetchingSummaryTable = true;
    }
    dismissLoadingSummaryTable() {
        this.fetchingSummaryTable = false;
    }
    launchCrumb(slug) {
        switch (slug) {
            case 'home':
                window.location.href = '/dashboard';
                break;
            case 'list':
                window.location.href = '/results/projects';
                break;
            case 'detail':
                window.location.href = `/results/projects?proposal=${this.raw_project_bag.proposal_id}`;
                break;
        }
    }
    setTab(key) {
        this.summaryController.tabs.forEach((tab) => {
            tab.active = false;
        });
        const tab = this.summaryController.tabs.find((tab) => tab.key === key);
        if (tab) {
            tab.active = true;
        }
    }
    isTabActive(key) {
        var _a;
        return (_a = this.summaryController.tabs.find((tab) => tab.key === key)) === null || _a === void 0 ? void 0 : _a.active;
    }
    showSummaryTableWithMetric(metric) {
        this.changeRelevant(false);
        this.changeMetric(metric);
        this.setTab('table');
        this.currentMode = 'table';
    }
    downloadCSVTable() {
        console.log('Download CSV');
    }
    get isVSMode() {
        const currentUrl = window.location.href;
        return (currentUrl.match(/\/(\d+)$/)) ? false : true;
    }
    toggleComparison() {
        this.summaryController.toggleComparison();
    }
    async created() {
        var _a;
        // 1. Get user
        if (this.raw_user)
            this.user = User_1.default.fromJson(this.raw_user);
        if (!this.isStudy) {
            await this.summaryController.fetchSummaryGlobalData((_a = this.raw_gheom.id) !== null && _a !== void 0 ? _a : -1);
        }
        // TODO (2023-11-22) Remove only for BMK
        if (!this.user.isBmk || !this.summaryGlobalHasMetrics) {
            this.setTab('table');
        }
        this.deployLoadingSummaryTable();
        /*         console.log({bag: this.raw_project_bag}) ;
        console.log({study: this.raw_study}) ; */
        const fetchedSummaryTable = this.isStudy
            ? await this.summaryController.fetchSummaryTable(this.raw_project_bag.id, this.raw_study.id)
            : await this.summaryController.fetchTrialsSummaryTable(this.raw_project_bag.id, this.raw_gheom.id || null);
        this.summaryController.setSummaryTable(fetchedSummaryTable);
        this.summaryController.updateWithProductSorting();
        (this.isStudy) ?
            this.summaryController.setFilter('relevant', 'true') :
            this.summaryController.setFilter('relevant', 'false');
        let initialQuestion = '';
        if (this.summaryController.getAllEffectNames.length > 0) {
            initialQuestion = this.summaryController.getAllEffectNames[0];
            if (initialQuestion !== 'Trials') {
                this.summaryController.setFilter('effectname', initialQuestion);
            }
        }
        if (this.raw_project_bag.proposal_id) {
            this.summaryController.setProposalID(this.raw_project_bag.proposal_id);
        }
    }
    mounted() {
        this.$emit('loaded');
    }
    updated() {
        this.dismissLoadingSummaryTable();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SummaryView.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], SummaryView.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "raw_study", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "raw_project_bag", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "raw_gheom", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "sidebar_selected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SummaryView.prototype, "becrop_crops", void 0);
SummaryView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ViewZero: bmk_ui_framework_1.ViewZero,
            StudiesLogo: bmk_ui_framework_1.StudiesLogo,
            PageHeading: bmk_ui_framework_1.PageHeading,
            Separator: bmk_ui_framework_1.Separator,
            CheckBox: bmk_ui_framework_1.CheckBox,
            RadioButtonsSet: bmk_ui_framework_1.RadioButtonsSet,
            RadioButton: bmk_ui_framework_1.RadioButton,
            TrialsLogo: bmk_ui_framework_1.TrialsLogo,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            GeneralFeatures: GeneralFeatures_vue_1.default,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            Loading: bmk_ui_framework_1.Loading,
            SummaryMetrics: SummaryMetrics_vue_1.default,
            TableSummary: TableSummary_vue_1.default,
            TableSummaryLegend: TableSummaryLegend_vue_1.default,
            TableSummaryFiltersRow: TableSummaryFiltersRow_vue_1.default,
            TabsSet: bmk_ui_framework_1.TabsSet,
            TabsSetItem: bmk_ui_framework_1.TabsSetItem,
            Tag: bmk_ui_framework_1.Tag,
            Tooltip: bmk_ui_framework_1.Tooltip,
            Dropdown: floating_vue_1.Dropdown,
            BannerHeader: BannerHeader_vue_1.default,
            TrialsResultsMain: TrialsResultsMain_vue_1.default,
            TrialsConfiguration: TrialsConfiguration_vue_1.default,
            TrialsResultsMainIntro: TrialsResultsMainIntro_vue_1.default,
            TrialsResultsMainTopAction: TrialsResultsMainTopAction_vue_1.default,
            TrialsTable: TrialsTable_vue_1.default,
            TrialsSummary: TrialsSummary_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            Download: lucide_vue_next_1.Download,
            XAloneIcon: bmk_ui_framework_1.XAloneIcon,
            Link: bmk_ui_framework_1.Link,
            FilterTag: FilterTag_vue_1.default,
            Toasts: bmk_ui_framework_2.Toasts,
            WarningRoundedIcon: bmk_ui_framework_2.WarningRoundedIcon,
        },
    })
], SummaryView);
exports.default = SummaryView;
